<template>
  <div id="FormTableHistoricalComponent">
    <v-card class="p-4">
      <v-spacer />
      <v-card-title>
        <v-text-field
          v-model="search"
          class="mb-4"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          filled
          rounded
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="formTable.headers"
          :items="formTable.items"
          item-key="name"
          sort-by="deleted_at_unix"
          sort-desc
          :loading="loading"
          :search="search"
          :options.sync="tableOptions"
          @update:items-per-page="saveLocalItemsPerPage($event)"
        >
          <template v-slot:no-data>
            <div class="my-4">
              <p>No forms found</p>
            </div>
          </template>
          <template v-slot:loading>
            <div class="my-4">
              <p>Loading forms...</p>
            </div>
          </template>
          <template v-slot:[`item.is_global`]="{ item }">
            <v-icon
              v-if="!!item.is_global"
              class="m-2"
              color="green"
            >
              mdi-earth
            </v-icon>
          </template>
          <template v-slot:[`item.grace_period`]="{ item }">
            <span
              class="font-weight-medium"
              :style="gracePeriodColor(item.grace_period)"
            >{{ item.grace_period }} days</span>
          </template>
          <template v-slot:[`item.deleted_at_unix`]="{ item }">
            {{ item.deleted_at }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              title="restore"
              color="agency-color-primary"
              class="white--text"
              fab
              small
              depressed
              @click="prompt(item, 'restore')"
            >
              <v-icon>mdi-restore</v-icon>
            </v-btn>
            <!-- <v-btn
              title="permanent delete"
              color="red"
              class="white--text"
              :disabled="!!item.is_global && !is_admin"
              fab
              small
              depressed
              @click="prompt(item, 'delete')"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn> -->
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <action-dialog-component
      :loading="actionDialog.loading"
      :disabled="actionDialog.loading"
      :action-dialog="actionDialog"
      @closeDialog="actionDialog.show = false"
      @deleteItem="deleteForm()"
      @restoreItem="restoreForm()"
    />
  </div>
</template>
<script>
export default {
  name: 'FormTableHistoricalComponent',
  props: {
    //
  },
  data: () => ({
    selected: [],
    loading: true,
    search: '',
    formTable: {
      headers: [
        {
          text: 'Name',
          value: 'form_name'
        },
        {
          text: 'Global',
          value: 'is_global'
        },
        {
          text: 'Grace Period Remaining',
          value: 'grace_period'
        },
        {
          text: 'Archived At',
          value: 'deleted_at_unix'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'end',
          sortable: false
        }
      ],
      items: []
    },
    actionDialog: {
      show: false,
      action: '',
      item: {},
      loading: false
    }
  }),
  computed: {
    is_admin () {
      return this.$store.state.users.user.is_admin
    }
  },
  created () {
    const self = this
    self.LoadStateDependencies(['forms.historicalForms']).then(() => {
      self.formTable.items = self.$store.state.forms.historicalForms
      self.loading = false
    })
  },
  methods: {
    prompt (item, action) {
      this.actionDialog.show = true
      this.actionDialog.action = action
      this.actionDialog.item = item
      this.actionDialog.item.name = item.form_name
    },
    deleteForm () {
      const self = this
      self.actionDialog.loading = true
      self.$store
        .dispatch('forms/deleteForm', { id: self.actionDialog.item.id, force_delete: true })
        .then(response => {
          self.$store.dispatch('forms/setHistoricalForms').then(response => {
            self.formTable.items = self.$store.state.forms.historicalForms
            self.actionDialog.item = {}
            self.actionDialog.show = false
            self.actionDialog.loading = false
          })
        })
    },
    restoreForm () {
      const self = this
      self.actionDialog.loading = true
      self.$store
        .dispatch('forms/restoreForm', self.actionDialog.item)
        .then(response => {
          self.$store.dispatch('forms/setForms').then(() => {
            self.formTable.items = self.$store.state.forms.historicalForms
            self.actionDialog.item = {}
            self.actionDialog.show = false
            self.actionDialog.loading = false
          })
        })
    },
    gracePeriodColor ($days) {
      if ($days > 14) { return 'color: green' }
      if ($days < 7) { return 'color: red' }
      return 'color: orange'
    }
  }
}
</script>
